import React from 'react';
const TradeAcquisitionSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-trade-acquisition" });
TradeAcquisitionSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-trade-acquisition sirius-icon-jump-out-trade-acquisition-enhance" });
export default TradeAcquisitionSvg;
